import type {
  ServiceAccountingEntryDto,
  ServiceAccountingOperationDto,
} from '@shared/api/contracts';

const toEntryArray = (entries: ServiceAccountingEntryDto[] | unknown): ServiceAccountingEntryDto[] =>
  Array.isArray(entries) ? entries : [];

export const normalizeOperationDto = (
  operation: ServiceAccountingOperationDto,
): ServiceAccountingOperationDto => ({
  ...operation,
  relatedOperationIds: operation.relatedOperationIds ?? [],
  entries: toEntryArray(operation.entries),
  comments: Array.isArray(operation.comments) ? operation.comments : [],
});
